<script setup>
/* eslint-disable */
import { defineProps, defineEmits } from 'vue';

const props = defineProps({
  logo: { type: String, required: true },
  qrUrl: { type: String, default: null },
  codigoTamep: { type: String, default: 'N/A' },
  codigoTab: { type: String, default: '----' },
  procesoFinalizadoExitosa: { type: Boolean, default: false }
});

const emit = defineEmits(['imprimir', 'registrar-otro']);
</script>

<template>
  <div class="card shadow-lg border-0 position-sticky border-radius-2xl mb-4 card-custom overflow-hidden"
    style="top: 20px;">
    <div class="card-header bg-gray-100 py-2 d-print-none text-center border-bottom">
      <h6 class="text-xs font-weight-bold mb-0 text-azul-tamep">VISTA PREVIA ETIQUETA</h6>
    </div>
    <div class="card-body p-3 p-md-4 text-center">
      <div class="ticket-preview mx-auto shadow-sm">
        <div class="ticket-header">
          <img :src="logo" class="ticket-logo">
          <p class="ticket-title">EP TRANSPORTE AEREO MILITAR</p>
        </div>
        <div class="ticket-qr-container mt-2">
          <img v-if="qrUrl" :src="qrUrl" class="qr-real">
          <div v-else class="qr-placeholder"><i class="fas fa-qrcode fa-4x text-muted opacity-5"></i></div>
          <div class="mt-2 text-start px-2">
            <p class="ticket-code"><strong>COD:</strong> {{ codigoTamep || 'N/A' }}</p>
            <p class="ticket-code"><strong>H:</strong> {{ codigoTab || '----' }}</p>
          </div>
        </div>
      </div>

      <button v-if="qrUrl" type="button" @click="emit('imprimir')" class="btn btn-dark w-100 mt-4 py-3">
        <i class="fas fa-print me-2"></i>IMPRIMIR ETIQUETA
      </button>

      <div v-if="procesoFinalizadoExitosa" class="mt-4 animate__animated animate__zoomIn">
        <div class="alert alert-success text-white border-0 shadow-lg mb-3 text-sm">
          <i class="fas fa-check-circle me-2"></i>¡Activo y Custodio Vinculados!
        </div>
        <button type="button" @click="emit('registrar-otro')"
          class="btn btn-success w-100 py-3 font-weight-bold text-sm">
          <i class="fas fa-plus me-2"></i>REGISTRAR OTRO
        </button>
      </div>
    </div>
  </div>
</template>
